<template>
  <div class="patrol_detail">
    <div class="report_detail">
      <div class="report_title">
        <div class="title"
             @click.stop="goBack">
          <span class="el-icon-arrow-left"></span>
          <span class="label">报告详情</span>
        </div>
        <div class="expandBtn"
             @click.stop="expandDetail">
          <div v-show="isExpand"
               style="text-align:right">
            <span style="color: #e0ebff;">收起</span>
            <span class="el-icon-arrow-up"></span>
          </div>
          <div v-show="!isExpand"
               style="text-align:right">
            <span style="color: #e0ebff;">展开</span>
            <span class="el-icon-arrow-down"></span>
          </div>
        </div>
      </div>
      <div :class="'report_content ' + (isExpand ? 'expand' : 'collspand')">
        <el-form :model="taskTitle"
                 label-width="100px"
                 :label-position="labelPosition">
          <el-row class="mb15">
            <el-col :span="7">
              <span>计划名称：{{taskTitle.taskName}}</span>
            </el-col>
            <el-col :span="6">
              <span>执行人：{{taskTitle.personInCharge}}</span>
            </el-col>
            <el-col :span="5">
              <span>状态：{{taskTitle.taskStatus}}</span>
            </el-col>
            <el-col :span="6">
              <div class="clock_content">
                <i class="click-icon finished"></i>
                <span class="clock">已打卡点：{{taskTitle.clockPointNum}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="mb15">
            <el-col :span="23"
                    style="margin-right:10px;">
              <span style="line-height: 30px">巡逻员：{{taskTitle.executorNames}}</span>
            </el-col>
          </el-row>
          <el-row class="mb15">
            <el-col :span="23">
              <span style="line-height: 30px">隶属中队：{{taskTitle.securityWorkGroupNames}}</span>
            </el-col>
          </el-row>
          <el-row class="mb15">
            <el-col :span="18">
              <span>计划巡更时间：{{taskTitle.recomTime}}</span>
            </el-col>

            <el-col :span="6">
              <div class="clock_content">
                <el-button type="text"
                           title="点击显示未打卡点"
                           @click="onShowPosition"
                           class="click-icon unfinished"></el-button>
                <!-- <i class="click-icon unfinished"></i> -->
                <span class="clock">未打卡点：{{taskTitle.unClockPointNum}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="mb15">
            <el-col :span="20">
              <span>实际巡更时间：{{taskTitle.realTime}}</span>
            </el-col>
          </el-row>
          <el-row class="mb15">
            <el-col :span="24">
              <ul class="report-desc">
                <li v-for="(reportDesc,index) in taskTitle.planReport"
                    :key="index">报告内容：{{reportDesc}}</li>
              </ul>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>   
import { api } from '../api';
import { Dates, Bus, Dic, Cache } from '$utils';
export default {
  components: {
    // mapGis
  },
  data () {
    return {
      igisMap: {},
      isExpand: true,
      taskTitle: {
        taskName: '',
        personInCharge: '',
        taskStatus: '',
        recomTime: '',
        realTime: '',
        clockPointNum: '',
        unClockPointNum: '',
        planReport: []
      },
      taskEndTime: '',
      taskStartTime: '',
      taskName: '',
      taskStatus: '',
      labelPosition: 'top',
      // 地图打点图标图层对象
      deviceIconObj: null,
      // 地图撒点数据 
      drawPoint: [],
      // 任务状态自定义字典
      taskStatusType: {
        "1": '待巡逻',
        "2": '巡逻中',
        "3": '已完成',
        "4": '已超时',
      },
      patrolTaskCode: '',
      taskLocations: [],
      unTaskLocations: [],
      // 打卡范围
      deviation: ''
    }
  },
  beforeDestroy () {
    this.$map.hideMap2D();
    this.$map.clear();
    this.$map.MapInstance2D.closeTips()
  },
  mounted () {
    this.$map.showMap2D(this.initPage);
  },
  methods: {
    // 定位第一个未打卡点位
    onShowPosition () {
      if (this.unTaskLocations.length) {
        let center = [
          Number(this.unTaskLocations[0].longitude) || 118.0302643113,
          Number(this.unTaskLocations[0].latitude) || 35.2692087027,
        ];
        this.$map.MapInstance2D.positionByPoint(center)
      }

    },
    mapPoint (points, type) {
      console.log('---所有的points', points);
      if (type == 'task') {
      this.$map.MapInstance2D.removeTrajectory();
        //绘制已经打点的轨迹
        let setPoint = []
        points.map((val, index) => {
          val.clockTime ? val.clockTime = Dates.dayjs(val.clockTime).format('YYYY-MM-DD HH:mm:ss') : ''
          setPoint.push({
            point: (function () {
              let ary = []
              ary.push(val.longitude)
              ary.push(val.latitude)
              if (val.clock == 0) {
                ary.push(`/images/theme/newDark/map/unfinish_click.png`)
              } else {
                ary.push(`/images/theme/newDark/map/finish_click.png`)
              }
              ary.push(Object.assign({}, { type: "patrolRecord" }, val))
              return ary
            })(val)
          });
        });
        this.$map.MapInstance2D.drawTrajectory(setPoint, 1.2);
        return
      }
      // 绘制未打卡的点位
      let detailPoint = [];
      points.map((item, index) => {
        item.clockTime ? item.clockTime = Dates.dayjs(item.clockTime).format('YYYY-MM-DD HH:mm:ss') : ''
        detailPoint.push({
          id: item.deviceId,
          coord: [Number(item.longitude), Number(item.latitude)],
          anchor: [10, 12],
          scale: 1,
          src:
            `images/theme/newDark/map/${item.clock == "0" ? 'unfinish_click.png' : 'finish_click.png'}`,
          attr: item,
          tipsTitle: '打卡详情',
          showTips: true,
          tipsMap: {
            clockTime: '打卡时间',
            clockPerson: '打卡人',
          }
        });
        
      });
      this.$map.MapInstance2D.addMarket(detailPoint, type)
      this.$map.MapInstance2D.setMapCenter(detailPoint.length && detailPoint[0].coord)

    },
    initPage () {
      console.log('执行初始化地图');
      this.queryRecDetail();
    },
    // 创建图标图层,添加地图打点数据
    // 查询巡更记录详情
    queryRecDetail () {
      const self = this;
      let patrolTaskCode = this.$route.params && this.$route.params.patrolTaskCode;
      if (patrolTaskCode) {
        this.patrolTaskCode = patrolTaskCode
        Cache.put("dormNewData", this.patrolTaskCode);
      } else {
        this.patrolTaskCode = Cache.get("dormNewData");
      }
      self.$fetch(api.patrolTask.queryPatrolTaskDetail, { patrolTaskCode: this.patrolTaskCode }).then(res => {
        // 取详情接口中的数据,进行打点
        this.taskLocations = res.returnObj.taskLocations;
        this.unTaskLocations = res.returnObj.uncompleteTaskLocations;
        this.deviation = res.returnObj.deviation;
        if (res.returnObj && res.returnObj.taskLocations && res.returnObj.taskLocations.length) {
          this.mapPoint(res.returnObj.taskLocations, "task")
        }
        res.returnObj.uncompleteTaskLocations.length && this.mapPoint(res.returnObj.uncompleteTaskLocations, "unTask")
        if (res.returnObj) {
          let recomStartTime = res.returnObj.taskStartTime ? Dates.format(new Date(res.returnObj.taskStartTime), 'yyyy-MM-dd HH:mm:ss') : "";
          let recomEndTime = res.returnObj.taskEndTime ? Dates.format(new Date(res.returnObj.taskEndTime), 'yyyy-MM-dd HH:mm:ss') : "";
          let realStartTime = res.returnObj.realStartTime ? Dates.format(new Date(res.returnObj.realStartTime), 'yyyy-MM-dd HH:mm:ss') : "";
          let realEndTime = res.returnObj.realEndTime ? Dates.format(new Date(res.returnObj.realEndTime), 'yyyy-MM-dd HH:mm:ss') : "";
          this.taskTitle = {
            taskName: res.returnObj.taskName,
            personInCharge: res.returnObj.reportPerson,
            taskStatus: this.taskStatusType[res.returnObj.taskStatus],
            recomTime: recomStartTime + " 至 " + recomEndTime,
            realTime: realStartTime + " 至 " + realEndTime,
            executorNames: res.returnObj.executorNames,
            securityWorkGroupNames: res.returnObj.securityWorkGroupNames,
            clockPointNum: res.returnObj.taskLocations.length,
            unClockPointNum: res.returnObj.uncompleteTaskLocations.length,
            planReport: res.returnObj.planReport && res.returnObj.planReport.split('</br>')
          }
        }
      })
    },
    // 返回报告列表页面
    goBack () {
      this.$router.push({
        name: 'patrolrecord'
      })
    },
    // 收起展开详情列表
    expandDetail () {
      this.isExpand = !this.isExpand;
    }
  }
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.patrol_detail {
  width: 100%;
  height: 100%;
  .ioc-alarm__warp {
    height: 100%;
  }
  .report_detail {
    z-index: 10001;
    opacity: 0.8;
    width: 700px;
    position: absolute;
    top: 10%;
    left: 25%;
    .report_title {
      line-height: 24px;
      // font-size: 18px!important;
      color: #e0ebff;
      // background: #303541;
      @include set_theme_color(background-color, item-active-bg-color);
      text-indent: 1%;
      cursor: pointer;
      .title {
        display: inline-block;
        width: 150px;
        padding: 5px 0;
        // color: #12a1a0;
      }
      // .label {
      //   margin-left: 5px;
      // }
      .el-icon-arrow-up {
        margin: 0 10px 0 5px;
      }
      .el-icon-arrow-down {
        margin: 0 10px 0 5px;
      }
    }
    .expandBtn {
      float: right;
      font-size: 14px;
      width: 100px;
      padding: 5px;
      color: #0084ff;
    }
    .report_content {
      padding: 15px;
      // background: #3b404c;
      @include set_theme_color(background-color, top-menu-bg-color);
      transition: all 0.5s;
      &.collspand {
        height: 0;
        display: none;
      }
      .clock_content {
        // position: relative;
        display: flex;
        align-items: center;
        .click-icon {
          flex: 1;
          // position: absolute;
          // top: 2px;
          // left: 0;
          // display: inline-block;
          // width: 24px;
          height: 24px;
          &.finished {
            background: url("/images/theme/newDark/map/finish_click.png") center
              center no-repeat;
          }
          &.unfinished {
            background: url("/images/theme/newDark/map/unfinish_click.png")
              center center no-repeat;
          }
        }
        .clock {
          flex: 1;
          margin-left: -35px;
        }
      }
      .report-desc {
        max-height: 170px;
        overflow-y: auto;
      }
      .show-overflow-tooltip {
        // display: inline-block;
        // max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .el-form--label-left .el-form-item__label {
    text-align: right;
  }
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
  padding: 5px 0 5px 0;
}
</style>